import { getLenisInstance } from '../core/scroll-manager.js';

let lenis;
let scrollHandler;

/**
 * Animates the opacity of the hero background overlay based on scroll position.
 * Sets a CSS variable --hero-overlay-opacity on the hero element.
 * 
 * CSS Usage:
 * .hero[data-type="1"] .hero__bg::before,
 * .hero[data-type="3"] .hero__bg::before {
 *     opacity: var(--hero-overlay-opacity, 0);
 * }
 */
let vh = window.innerHeight;
let resizeHandler = null;

export function initializeHeroScrollOpacity(container = document) {
    destroyHeroScrollOpacity();

    lenis = getLenisInstance();
    if (!lenis) return;

    const hero = container.querySelector('.hero[data-type="1"] .hero__bg, .hero[data-type="2"] .hero__bg, .hero[data-type="3"] .hero__bg');
    if (!hero) return;

    vh = window.innerHeight;
    resizeHandler = () => { vh = window.innerHeight; };
    window.addEventListener('resize', resizeHandler, { passive: true });
    window.addEventListener('orientationchange', resizeHandler, { passive: true });

    let pendingAnimation = false;

    scrollHandler = ({ scroll }) => {
        if (pendingAnimation) return;
        pendingAnimation = true;

        requestAnimationFrame(() => {
            pendingAnimation = false;
            let opacity = (scroll / (vh || 1)) * 0.8;
            if (opacity > 0.8) opacity = 0.8;
            if (opacity < 0) opacity = 0;

            hero.style.setProperty('--hero-overlay-opacity', opacity.toFixed(3));
        });
    };

    lenis.on('scroll', scrollHandler);
    // Initial update
    scrollHandler({ scroll: lenis.scroll });
}

export function destroyHeroScrollOpacity() {
    if (lenis && scrollHandler) {
        lenis.off('scroll', scrollHandler);
    }
    if (resizeHandler) {
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', resizeHandler);
        resizeHandler = null;
    }
    lenis = null;
    scrollHandler = null;
}